/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ImagePlaceholder from './ImagePlaceholder/index'
import No from './No/index'
import PatientImage from './PatientImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImageAction({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/ImageAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imagePatientImageValueData = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'patient_image',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imagePatientImageValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientImage'}>
<PatientImage
  viewPath={`${viewPath}/PatientImage`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImagePlaceholder'}>
<ImagePlaceholder
  viewPath={`${viewPath}/ImagePlaceholder`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}